var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 48,
    viewBox: "0 0 103 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.668 7.99243H79.1612C80.8291 7.99243 82.1897 8.53045 83.1341 9.47012C84.0768 10.4081 84.5834 11.7249 84.5849 13.2442C84.7035 15.3819 83.3792 17.3511 81.3688 17.9865L84.8951 23.9465H80.5348L77.4914 18.3879H75.5157V23.9465H71.668V7.99243ZM75.4548 11.3023V15.0781H78.6874L78.7005 15.0795C79.7121 15.1863 80.6298 14.4395 80.7385 13.3486L80.7386 13.3473C80.8449 12.3337 80.1051 11.4168 79.0266 11.3023H75.4548Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4688 7.99243H92.2556V14.4277L97.3629 7.99243H102.036L95.7369 15.5154L102.445 23.9465H97.7857L93.2142 17.9289L92.2556 19.0834V24.0076H88.4688V7.99243Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4119 7.99243H62.5889L68.8098 23.9465H64.8029L63.7681 21.2588H57.2942L56.2595 23.9465H52.2539L58.4119 7.99243ZM58.5233 17.8879H62.4173L60.4703 12.9003L58.5233 17.8879Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3214 8H45.5497V14.0472H39.5217V8H35.75V23.9389H39.5217V17.4641H45.5497V23.9389H49.3214V8Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8564 0L27.7127 8V24L13.8564 32L0 24V8L13.8564 0Z",
    fill: "#426CD7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8564 0L27.7127 8L13.8564 16V32L0 24V8L13.8564 0Z",
    fill: "#2E8ED3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8564 0L27.7127 8L13.8564 16L0 8L13.8564 0Z",
    fill: "#1BAFCF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7103 8L13.854 24L6.92578 20V12L27.7103 8Z",
    fill: "url(#paint0_linear_107_8537)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7103 8L13.854 24L6.92578 20L27.7103 8Z",
    fill: "#FFE094"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_8537",
    x1: 6.875,
    y1: 8,
    x2: 6.875,
    y2: 19.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA5B5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHark);
export default __webpack_public_path__ + "static/media/hark.718b7f59b7ae8f234b4fb2cd433ec601.svg";
export { ForwardRef as ReactComponent };